import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import {
  faArrowRightToBracket,
  faCross,
  faGridHorizontal,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { LinkComponent } from '../../../atoms/link/link.component';
import LinkType from '../../../../shared/enums/link-type.enums';
import { NavigationPage } from '../../../../shared/interfaces/navigation-page.interface';
import { FlyoutService } from '../../../../services/flyout.service';
import { Subscription } from 'rxjs';
import { IconComponent } from '../../../atoms/icon/icon.component';
import { CapitalizePipe } from '../../../capitalize.pipe';

@Component({
  selector: 'hdi-flyout',
  standalone: true,
  imports: [
    CommonModule,
    LinkComponent,
    RouterModule,
    IconComponent,
    CapitalizePipe,
  ],
  templateUrl: './flyout.component.html',
  styleUrl: './flyout.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class FlyoutComponent implements OnDestroy, OnInit {
  @Input() isSimple: boolean = true;
  @Input() pages: Array<NavigationPage> = [];
  @Input() title: string = '';
  @Input() overviewUrl: string = '';
  @Output() closeFlyout = new EventEmitter<void>();

  public isOpenSubscription: Subscription = new Subscription();

  protected readonly faArrowRightToBracket = faArrowRightToBracket;
  protected readonly faGridHorizontal = faGridHorizontal;
  protected readonly faCross = faCross;
  protected readonly faXmark = faXmark;
  protected readonly LinkType = LinkType;

  constructor(
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2,
    private readonly flyoutService: FlyoutService
  ) {}

  scrollPosition = { x: 0, y: 0 };
  getScrollPosition(): void {
    if (typeof window !== 'undefined') {
      this.scrollPosition = {
        x: window.scrollX,
        y: window.scrollY,
      };
    }
  }

  ngOnInit(): void {
    this.getScrollPosition();
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
    this.isOpenSubscription = this.flyoutService.isFlyoutOpen$.subscribe(
      (isOpen) => {
        if (!isOpen) {
          this.close();
        }
      }
    );
  }
  public close() {
    this.closeFlyout.emit();
  }

  navigateToOverview() {
    this.router.navigate([this.overviewUrl]);
    this.close();
  }

  navigateToPage(url: string) {
    this.router.navigate([url]);
    this.close();
  }

  ngOnDestroy(): void {
    this.renderer.setStyle(this.document.body, 'overflow', 'auto');
    this.isOpenSubscription.unsubscribe();
  }
}
